/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import { ucwords } from '../../../../helper';
import CreateBusinessActivity from '../BusinessActivity/CreateBusinessActivity';
import UpdateNewBusinessActivity from './UpdateNewBusinessActivity';

function NewBusinessActivityList({ value, onChange }) {
  const [viewForm, setViewForm] = useState(false);
  const [viewUpdateForm, setViewUpdateForm] = useState(false);
  const [formData, setFormData] = useState('');

  const [items, setItem] = useState({
    item: [],
  });

  useEffect(() => {
    let result = value;
    result = result.map((n, i) => {
      return {
        ...n,
        id: i + 1,
      };
    });
    setItem({
      item: result || [],
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.length]);

  const updateProps = newItem => {
    onChange(_.get(newItem, 'item'));
  };

  // const handleAddBusinessActivity = e => {
  //   e.preventDefault();
  //   setViewForm(true);
  //   setViewUpdateForm(false);
  // };

  const closeUpdateModal = () => {
    setViewUpdateForm(false);
  };

  const handleUpdateBusinessActivity = data => e => {
    e.preventDefault();
    setViewUpdateForm(true, setFormData({...data, capital_amount: _.get(data, 'capital_amount') === 0 ? '' : _.get(data, 'capital_amount')}));
  };

  const closeModal = () => {
    setViewForm(false);
  };

  // const handleRemoveBusinessActivity = (data) => () => {

  //   ConfirmAlert(
  //     'Are you sure you want to remove this business activity?',
  //     () => {
  //       const newItem = {
  //         item: (items.item || []).filter(x => x.id === data.id)
  //       };
  //       setItem(newItem);
  //       updateProps(newItem);
  //     },
  //     () => { },
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     }
  //   );
  // };

  const handleOnCreate = data => e => {
    e.preventDefault();
    const details = _.omit(
      data,
      'business_nature_id',
      'business_line_id',
      'capital_amount',
      'gross_amount'
    );

    ConfirmAlert(
      'Are you sure you want to add this business activity?',
      () => {
        const newItem = {
          item: (items.item || []).concat([
            {
              id: (_.get(items, `item.${items.item.length - 1}.id`) || 0) + 1,
              business_nature_id: _.get(data, 'business_nature_id'),
              business_line_id: _.get(data, 'business_line_id'),
              line_of_business: _.get(data, 'line_of_business'),
              capital_amount: _.get(data, 'capital_amount'),
              gross_amount: _.get(data, 'gross_amount'),
              details: { ...details },
            },
          ]),
        };
        setItem(newItem);
        updateProps(newItem);
        setViewForm(false);
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnUpdate = (data, optionFields) => e => {

    e.preventDefault();
    const details = _.omit(
      data,
      'business_nature_id',
      'business_line_id',
      'capital_amount',
      'gross_amount',
      'activity_id',
      'business_line_id',
      'business_nature_id',
      'capital_amount',
      'gross_amount',
      'id',
      'line_of_business',
      'initial_data'
    );

    const filteredByKey = optionFields.reduce((result, key) => ({ ...result, [key.multiplier]: details[key.multiplier] }), {});

    ConfirmAlert(
      'Are you sure you want to update this business activity?',
      () => {
        const finalItem = items.item.map(ele => {
          if (ele.id === data.id) {
            return {
              ...ele,
              business_nature_id: +_.get(data, 'business_nature_id'),
              business_line_id: +_.get(data, 'business_line_id'),
              line_of_business: _.get(data, 'line_of_business'),
              capital_amount: _.get(data, 'capital_amount'),
              gross_amount: _.get(data, 'gross_amount'),
              activity_id: _.get(data, 'activity_id'),
              details: { ...filteredByKey },
            };
          }
          return ele;
        });

        const newItem = {
          item: finalItem,
        };
        setItem(newItem);
        updateProps(newItem);
        setFormData({});

        setViewUpdateForm(false);
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="p-2">
      <table className="transaction-table table table-sm border-0 custom-table my-1">
        <thead>
          <tr className="text-primary text-center">
            <th
              width="200"
              className="border-left border-top border-bottom py-3"
            >
              Line of Business
            </th>
            <th width="200" className="border-left border-top border-bottom">
              Philippine Standard Industrial Code
            </th>
            <th
              width="300"
              className="border-left border-top border-bottom py-3"
            >
              Details
            </th>
            <th
              width="250"
              className="border-left border-top border-bottom py-3 border-right"
            >
              Total Capitalization (Ph)
            </th>
          </tr>
        </thead>
        <tbody>
          {(items.item || []).map((item, i) => (
            <tr key={`Item ${i + 1}`}>
              <td>
                {!_.isEmpty(_.get(item, 'business_line_name')) ? (
                  <input
                    type="text"
                    readOnly
                    className="custom-input my-2"
                    value={_.get(item, 'business_line_name') || '-'}
                  />
                ) : (
                  <input
                    type="text"
                    readOnly
                    className="custom-input my-2"
                    value={_.get(item, 'initial_data.line_of_business') || '-'}
                  />
                )}
              </td>
              <td>
                <input
                  type="text"
                  readOnly
                  className="custom-input my-2"
                  value={_.get(item, 'industrial_code') || '-'}
                />
              </td>
              <td>
                {_.get(item, 'details')
                  ? Object.entries(_.get(item, 'details')).map(x => {
                    return (
                      <input
                        key={`bpls_business_detail${x[0]}`}
                        type="text"
                        readOnly
                        className="custom-input my-2 text-uppercase"
                        value={`${ucwords(
                          x[0].replace(/_/g, ' ') || null
                        )}: ${x[1] || null}`}
                      />
                    );
                  }) || '-'
                  : ''}
              </td>
              <td>
                <NumberFormat
                  name="capital_amount"
                  id="capital_amount"
                  placeholder="0"
                  className="custom-input my-2"
                  /* eslint-disable */
                  isNumericString={true}
                  thousandSeparator={true}
                  allowNegative={true}
                  allowLeadingZeros={true}
                  displayType="input"
                  prefix=""
                  value={_.get(item, 'capital_amount') || '-'}
                  readOnly
                />
              </td>
              <td className="text-center">
                <div className="d-flex justify-content-center align-items center my-2">
                  <button
                    onClick={handleUpdateBusinessActivity(item, i)}
                    type="button"
                    className="btn-blank btn-sm"
                    disabled={viewUpdateForm === true}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                  {/* <button
                    type="button"
                    className="btn-blank btn-sm"
                    onClick={handleRemoveBusinessActivity(item)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button> */}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {viewForm === true && (
        <CreateBusinessActivity
          closeModal={closeModal}
          handleOnCreate={handleOnCreate}
        />
      )}
      {viewUpdateForm === true && (
        <UpdateNewBusinessActivity
          closeModal={closeUpdateModal}
          businessActivityInfo={formData}
          handleOnUpdate={handleOnUpdate}
        />
      )}
      {/* <div>
        <button
          type="button"
          className="btn-primary cms-bg-color-primary cms-outline-primary     btn-md border-0 rounded text-sm py-2 px-4"
          onClick={handleAddBusinessActivity}
        >
          <i className="fas fa-plus mr-1" />
          Add another
        </button>
      </div> */}
    </div>
  );
}

NewBusinessActivityList.propTypes = {
  value: PropTypes.instanceOf(Array).isRequired,
  onChange: PropTypes.instanceOf(Function).isRequired,
};

const enhance = _.flowRight([withRouter]);

export default enhance(NewBusinessActivityList);
